import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const PaymentUPIList = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [invoiceList, setIvoiceList] = useState([]);
  const [walletAmount, setWalletAmount] = useState("");
  const [upiList, setUPIList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);

  useEffect(() => {
   
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    getbankList();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };

  const withdraw = (id) => {
    setLoading(true)
    const FormData = require("form-data");

    const form = new FormData();
    form.append("request_amount", location.state.data);
    form.append("request_bank_id", id);

    commonService
      .CommonService("withdraw_request", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setTimeout(() => {window.location.href = '/payment'},1000)
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false)
      });
  };


  const getbankList = () => {
    setLoading(true)
    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("UPI_account_list", form)
      .then(async (res) => {
        if (res.status == 200) {
          setUPIList(res.data)
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false)
      });
  };

  
  return (
    <section className="explore explore1">
    <div className="container">
      <div className="banner">
        <div className="row">
          <div className="col-md-4">
            <div className="breadcrumps">
            <ul>
                    <li><a href="#" onClick={(e)=>{
                   e.preventDefault();
                   history.goBack();
                }}><i className="bx bx-chevron-left" /> Back</a></li>
                  </ul>
            </div>
          </div>
       
        </div>
      </div>
      <section className="onbord-section">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1 className="title">Saved UPI Details</h1>
            <p className="subtitle" />
          </div>
        </div>
        <div className="row">
        <div className="col-md-12">
            <div className="board-box board-box2 post-new-job">
            <div className="col-md-12 add-account-btn ">
                  <a href onClick={()=>{
                                                          history.push("/addUPI");

                  }}>Add UPI</a>
                </div>
            <LoadingOverlay>
                  {upiList.map((item) => (
                     <div >
                <div className="saved-bank-account" onClick={()=>{
                      withdraw(item.id)
                    }}>
                  <h5>{item.upi_id}</h5>
                  <p>{item.address}</p>
                </div>
                <div className="col-md-12 add-account-btn ">
        {/* <a href onClick={(e)=>{
          e.preventDefault();
                                                          history.push("/updateUPI",item);

                  }}>Update UPI</a> */}

                  <button 
                    className="payment-sbt" 
                    onClick={(e) => {
                      e.preventDefault();
                      withdraw(item.id);
                    }}
                  >
                    SUBMIT
                  </button>
                </div>
                </div>
               ))}
 <Loader loading={loading} />
                </LoadingOverlay>
            </div>
            </div>
        </div>
      </section>
    </div>
  </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentUPIList);
